import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '@/api/fe-api/domain/repositories/capacity-evaluation.repository';

export namespace GetAllJobs {
  export const key = (input: Input) => [
    'capacity-evaluation',
    'get-all-jobs',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ICapacityEvaluationRepository.GetAllInput;
  export type Output = ICapacityEvaluationRepository.GetAllOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.capacityEvaluation.getAll(input),
    });
  }
}
